import { Route, Routes, useParams } from "react-router";

import NotFoundPage from "components/error/NotFoundPage";
import PageLoading from "components/loading/PageLoading";
import useCanViewUsersPersonalApiKeys from "shared/ApiKey/access/useCanViewUsersPersonalApiKeys";

import useGetUser from "./useGetUser";
import UserPageLayout from "./PageLayout";
import UserRoles from "./Roles";
import UserIdpGroups from "./IdpGroups";
import UserIntegrations from "./Integrations";
import UserPersonalApiKeys from "./PersonalApiKeys";

const User = () => {
  const { userId } = useParams<{ userId: string }>();
  const { user, error, loading, refetch } = useGetUser({
    id: userId,
  });
  const canViewUsersPersonalApiKeys = useCanViewUsersPersonalApiKeys();

  if (loading && !user) {
    return <PageLoading />;
  }

  if (!user) {
    return <NotFoundPage />;
  }

  if (error) {
    return null;
  }

  return (
    <UserPageLayout user={user}>
      <Routes>
        <Route
          index
          element={
            <UserRoles
              userId={user.id}
              roleBindings={user.userRoleBindings}
              userName={user.username}
              refetch={refetch}
            />
          }
        />
        <Route path="idp-groups" element={<UserIdpGroups userName={user.username} />} />
        <Route path="integrations" element={<UserIntegrations user={user} />} />
        {canViewUsersPersonalApiKeys && (
          <Route path="personal-api-keys" element={<UserPersonalApiKeys user={user} />} />
        )}
      </Routes>
    </UserPageLayout>
  );
};

export default User;
